import { IObject } from "@quest/adapter-interface";
import { Model } from "@quest/platform-murka-phase_2/dist";

export class GameParserModel extends Model {
  private reelsSets: any;
  private jackpotData: any;
  private stickyWildData: any;
  private collectWildData: any;
  private holdAndRespinStatus: boolean;
  private jackpotAmt: number;
  private totalReSpin: number;
  private jackpotAvailable: boolean;
  private holdAndRespinTotalWin: number;
  private holdAndRespinType: number[] = [];
  private holdAndRespinSpinData: IObject[] = [];
  private currentReSpin: number = 0;
  private stickyWildDataRawData:number[] = []
  private bonusTriggeringData: {
    offSet: number[];
    pos: number;
    color: string;
    symbolType: number;
    prize: number;
    multiplier: number;
    reward: string;
  }[] = [];
  private updateCoinData: { offSet: number[][]; position: number; color: string; multiplier: number; symbolType: number }[] = [];
  private initialCoinsData: { offSet: number[][]; position: number; color: string; multiplier: number }[] = [];
  public coinTypeToColor: { [key: string]: string } = {
    "150": "golden",
    "151": "multiplier",
    "152": "bigPrize",
    "153": "collectAll",
  };
  private triggeringCoinsData: {
    offSet: number[][];
    position: number;
    color: string;
    multiplier: number;
    reward: string;
    symbolType: number;
  }[] = [];
  private bonusWinCoinData: { offSet: number[][]; position: number; color: string; multiplier: number; prize: number; reward: string }[] =
    [];
  private totalRedElementCount: number = 0;
  private totalGreenElementCount: number = 0;
  private totalBlueElementCount: number = 0;
  private freeSpinSymbolsOffsets: number[][] = [];
  private isWildWin: boolean = false;

  setReelSets(value: any): void {
    this.reelsSets = value;
  }
  getReelSets(value: string): any {
    return this.reelsSets[value];
  }
  setJackpotData(value: any): void {
    this.jackpotData = value;
  }
  getJackpotData(): any {
    return this.jackpotData;
  }
  setStickyWildData(value: any): void {
    this.stickyWildData = value;
  }
  getStickyWildData(): any {
    return this.stickyWildData;
  }
  setCollectWildData(value: any): void {
    this.collectWildData = value;
  }
  getCollectWildData(): any {
    return this.collectWildData;
  }

  /**
   * Model to get free spin symbol offsets
   * @returns
   */
  public getFSSymbolOffsets(): number[][] {
    return this.freeSpinSymbolsOffsets;
  }
  /**
   * Model to set free spin symbol offsets
   * @returns
   */
  public setFSSymboloffsets(value: number[][]): void {
    this.freeSpinSymbolsOffsets = value;
  }
  //hold'n'respin

  setHoldAndRespinStatus(value: boolean): void {
    this.holdAndRespinStatus = value;
  }

  getHoldAndRespinStatus(): boolean {
    return this.holdAndRespinStatus;
  }

  setJackpotAmount(value: number): void {
    this.jackpotAmt = value;
  }

  getJackpotAmount(): number {
    return this.jackpotAmt;
  }

  setTotalReSpin(value: number): void {
    this.totalReSpin = value;
  }

  getTotalReSpin(): number {
    return this.totalReSpin;
  }
  setJackpotAvailable(value: boolean): void {
    this.jackpotAvailable = value;
  }
  getJackpotAvailable(): boolean {
    return this.jackpotAvailable;
  }
  setHoldAndRespinTotalWin(value: number): void {
    this.holdAndRespinTotalWin = value;
  }
  getHoldAndRespinTotalWin(): number {
    return this.holdAndRespinTotalWin;
  }
  // set bonus triggering coins data
  public setBonusCoinsInitialData(value: any[]): void {
    this.initialCoinsData = value;
  }

  // Bonus Symbol Triggering offsets
  public getBonusCoinsInitialData(): any[] {
    return this.initialCoinsData;
  }

  public setBonusWinCoinData(value: any): void {
    this.bonusWinCoinData = value;
  }

  public getBonusWinCoinData(): any {
    return this.bonusWinCoinData;
  }

  // set bonus triggering coins data
  public setUpdatedBonusCoinsData(value: any[]): void {
    this.updateCoinData = value;
  }

  // Bonus Symbol Triggering offsets
  public getUpdatedBonusCoinsData(): any[] {
    return this.updateCoinData;
  }
  // Bonus Symbol Triggering offsets
  public setBonusTriggeringOffset(
    value: { offSet: number[]; pos: number; color: string; symbolType: number; prize: number; multiplier: number; reward: any }[]
  ): void {
    this.bonusTriggeringData = value;
  }

  // Bonus Symbol Triggering offsets
  public getBonusTriggeringOffset(): {
    offSet: number[];
    pos: number;
    color: string;
    symbolType: number;
    prize: number;
    multiplier: number;
  }[] {
    return this.bonusTriggeringData;
  }

  public getHoldAndRespinSpinData(): IObject[] {
    return this.holdAndRespinSpinData;
  }

  public setHoldAndRespinSpinData(value: IObject[]): void {
    this.holdAndRespinSpinData = value;
  }

  // set bonus triggering coins data
  public setBonusCoinsData(value: any[]): void {
    this.triggeringCoinsData = value;
  }

  // Bonus Symbol Triggering offsets
  public getBonusCoinsData(): any[] {
    return this.triggeringCoinsData;
  }

  public setCurrentReSpin(value: number): void {
    this.currentReSpin = value;
  }

  public getCurrentReSpin(): number {
    return this.currentReSpin;
  }

  public getHoldAndRespinType(): number[] {
    return this.holdAndRespinType;
  }

  public setHoldAndRespinType(value: number[]): void {
    this.holdAndRespinType = value;
  }

  // set bonus triggering coins data
  public setRedElementCount(value: number): void {
    this.totalRedElementCount = value;
  }

  // Bonus Symbol Triggering offsets
  public getRedElementCount(): number {
    return this.totalRedElementCount;
  }

  public getRedStage(): number {
    if (this.totalRedElementCount < 3) {
      return 1;
    } else if (this.totalRedElementCount >= 3 && this.totalRedElementCount < 5) {
      return 2;
    } else if (this.totalRedElementCount >= 5) {
      return 3;
    }
  }

  public getBlueStage(): number {
    if (this.totalBlueElementCount < 3) {
      return 1;
    } else if (this.totalBlueElementCount >= 3 && this.totalBlueElementCount < 5) {
      return 2;
    } else if (this.totalBlueElementCount >= 5) {
      return 3;
    }
  }

  public getGreenStage(): number {
    if (this.totalGreenElementCount < 3) {
      return 1;
    } else if (this.totalGreenElementCount >= 3 && this.totalGreenElementCount < 5) {
      return 2;
    } else if (this.totalGreenElementCount >= 5) {
      return 3;
    }
  }

  public setGreenElementCount(value: number): void {
    this.totalGreenElementCount = value;
  }

  public getGreenElementCount(): number {
    return this.totalGreenElementCount;
  }

  public getBlueElementCount(): number {
    return this.totalBlueElementCount;
  }

  public setBlueElementCount(value: number): void {
    this.totalBlueElementCount = value;
  }
   // Setter & Getter function for wild win available
  public getStickyWildDataRawData(): number[] {
    return this.stickyWildDataRawData;
  }

  public setStickyWildDataRawData(value: number[]): void {
    this.stickyWildDataRawData = value;
  }


  // Setter & Getter function for wild win available
  public getIsWildWin(): boolean {
    return this.isWildWin;
  }

  public setIsWildWin(value: boolean): void {
    this.isWildWin = value;
  }
}
